<script>
	export let block;
	export let data;
	export let index;
	export let j;
	export let type = "";

	let opened;

	import {
		saved,
		changed,
		isNewDataChanged,
	} from "../../../../../stores/variables";
	import { cloneDeep } from "lodash-es";

	$: if ($saved) {
		if ($saved === "saved") {
			opened = false;
			if (
				data[data.field_name] &&
				data[data.field_name][index] &&
				data[data.field_name][index].active
			) {
				$isNewDataChanged = true;
				block.newData[block.field_name] = block.value;
				data[data.field_name][index][j] = block;
				data.loadedData[index][block.field_name] = block.value;
				data.loadedData[index]["toUpdate"] = true;

				if (data.newData[data.field_name].length < 1) {
					data.newData[data.field_name].push(data.loadedData[index]);
				} else {
					let check = false;
					data.newData[data.field_name].forEach((new_sp) => {
						if (new_sp["ID"] == data.loadedData[index]["ID"])
							check = true;
					});
					if (!check) {
						data.newData[data.field_name].push(
							data.loadedData[index]
						);
						check = false;
					}
				}
			}
			if (
				data[data.field_name + "_new"] &&
				data[data.field_name + "_new"][index] &&
				data[data.field_name + "_new"][index].active
			) {
				$isNewDataChanged = true;
				if (block.value) {
					block.newData[block.field_name] = block.value;
					data.createdData[index][block.field_name] = block.value;
				} else {
					block.newData[block.field_name] = "";
					data.createdData[index][block.field_name] = "";
				}
				data[data.field_name + "_new"][index][j] = block;
				if (!data.newData[data.field_name])
					data.newData[data.field_name] = [];
				if (data.newData[data.field_name].length < 1) {
					data.newData[data.field_name].push(data.createdData[index]);
				} else {
					let check = false;
					data.newData[data.field_name].forEach((new_sp) => {
						if (new_sp.temp_id == data.createdData[index].temp_id)
							check = true;
					});
					if (!check) {
						data.newData[data.field_name].push(
							data.createdData[index]
						);
						check = false;
					}
				}
			}
		}
		if ($saved === "canceled") {
			opened = false;
			block.value = block.before.value;
		}
	}

	if (!block.newData) block.newData = [];
	if (!block.value) block.value = "";
	if (block.newData) {
		block.value = block.newData[block.field_name];
	}

	$: if (!opened) {
		opened = "1";
		if (!block.before) block.before = {};
		block.before.value = cloneDeep(block.value);
	}
</script>

{#if block}
	<div class="modal__item-name">
		<span class="modal__item-name-text">{block.name ? block.name : ""}</span
		>
	</div>
	{#if block.type == "number"}
		<input
			on:input={(e) => {
				e.target.value = e.target.value.replace(/[^\d.]/g, "");
				$changed = true;
			}}
			type="text"
			maxlength={block.maxlength ? block.maxlength : 255}
			placeholder={block.placeholder}
			bind:value={block.value}
		/>
	{:else}
		<input
			type="text"
			placeholder={block.placeholder}
			on:input={() => ($changed = true)}
			maxlength={block.maxlength ? block.maxlength : 255}
			bind:value={block.value}
		/>
	{/if}
{/if}

<style lang="scss">
	input {
		display: flex;
		width: 100%;
		font-size: 16px;
		padding: 18px 20px;
		color: var(--text-black);
		border: 0;
		outline: 0;
		border-right: 1px solid #eaebf2;
	}
</style>
